// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    getManagementGroupDetails as getManagementGroupDetailsService,
    GetManagementGroupDetailsApiParameter,
    ManagementGroupOptionsModel,
} from "@guestsupply/App/Services/ManagementGroupOptionsService";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type HandlerType = ApiHandler<
    GetManagementGroupDetailsApiParameter & HasOnSuccess<ManagementGroupOptionsModel> & HasOnError<string>,
    ServiceResult<ManagementGroupOptionsModel> & {
        errorMessage?: string;
    }
>;

export const CallManagementGroupDetailsApi: HandlerType = async props => {
    const managementGroupDetailsResult = await getManagementGroupDetailsService({ name: props.parameter.name });
    props.apiResult = managementGroupDetailsResult;
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};
export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};
export const chain = [CallManagementGroupDetailsApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const getManagementGroupDetails = createHandlerChainRunner(chain, "getManagementGroupDetails");
export default getManagementGroupDetails;
